<!-- 管理员管理 -->
<template>
  <BaseContainer
    class="dnnCloud-admin-box"
    :loading="listLoading"
    :isHasPageFt="!listLoading"
  >
    <template v-slot:hd>
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-form :inline="true" :model="souchs" @submit.native.prevent>
          <el-form-item>
            <el-input
              v-model="souchs.name"
              placeholder="姓名"
              @keyup.enter.native="getUser(1)"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="medium" v-on:click="getUser(1)"
              >查询</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="medium"
              @click="handleAdd"
              class="adds"
              >新增</el-button
            >
          </el-form-item>
        </el-form>
      </el-col>
    </template>

    <template v-slot:main>
      <!--列表-->
      <el-table
        :data="users"
        highlight-current-row
        v-loading="listLoading"
        @selection-change="selsChange"
        :height="maxTbHeight"
        style="width: 100%"
        :header-cell-style="getRowClass"
        @sort-change="handleSortChange"
      >
        <el-table-column
          type="index"
          :index="indexMethod"
          label="序号"
          width="100"
        >
          <template slot-scope="scope">
            <span>{{ (pageNumber - 1) * pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="phone"
          label="账号"
          min-width="180"
          sortable="custom"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="name"
          label="姓名"
          min-width="220"
          sortable="custom"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column label="类型" min-width="220" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{
              scope.row.type == "0"
                ? "超级管理员"
                : scope.row.type == "1"
                ? "系统管理员"
                : scope.row.type == "2"
                ? "客户经理"
                : scope.row.type == "3"
                ? "客户成功经理"
                : scope.row.type == "4"
                ? "经销商"
                : ""
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="intime"
          label="添加日期"
          min-width="180"
          sortable="custom"
          show-overflow-tooltip
        >
        </el-table-column>
        <!-- <el-table-column prop="" label="备注" min-width="180">
              </el-table-column> -->
        <el-table-column
          label="操作"
          min-width="220"
          style="text-algin: center"
        >
          <template slot-scope="scope" v-if="scope.row.type != '0'">
            <span class="operate">
              <el-tooltip effect="dark" content="编辑" placement="top">
                <span
                  class="dnnfont iconEdit"
                  @click="handleEdit(scope.$index, scope.row)"
                ></span>
              </el-tooltip>

              <el-tooltip
                effect="dark"
                content="删除"
                placement="top"
                v-if="!scope.row.delShow"
              >
                <span
                  class="dnnfont icondelete"
                  @click="handleDel(scope.$index, scope.row)"
                ></span>
              </el-tooltip>
            </span>

            <!-- <el-button type="primary" plain size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                  <el-button :disabled="scope.row.delShow" type="danger" plain size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>

      <!--新增界面-->
      <el-dialog
        class="model-edit"
        title="新增"
        :visible.sync="addFormVisible"
        :close-on-click-modal="false"
        @closed="closeAddform"
      >
        <el-form
          :model="addForm"
          label-width="80px"
          :rules="addFormRules"
          ref="addForm"
        >
          <el-row>
            <el-col :span="22">
              <el-form-item label="账号" prop="user">
                <el-input
                  v-model="addForm.user"
                  auto-complete="off"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="22">
              <el-form-item label="姓名" prop="name">
                <el-input
                  v-model="addForm.name"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="22">
              <el-form-item label="类型" prop="type">
                <el-select v-model="addForm.type">
                  <el-option
                    v-for="item in types"
                    :label="item.label"
                    :key="item.value"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="22">
              <el-form-item label="密码" prop="password">
                <el-input
                  type="password"
                  placeholder="请输入"
                  v-model="addForm.password"
                  @keyup.enter.native="addSubmit"
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="22"> 
                    <el-form-item label="备注" prop="beizhu">
                      <el-input type="textarea" :rows="2" v-model="addForm.beizhu"></el-input>
                    </el-form-item>
                  </el-col> -->
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: center">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button
            type="primary"
            @click.native="addSubmit"
            :loading="addLoading"
            >提交</el-button
          >
        </div>
      </el-dialog>

      <!--编辑界面-->
      <el-dialog
        class="model-edit"
        title="编辑"
        :visible.sync="editFormVisible"
        :close-on-click-modal="false"
        @closed="closeeditForm"
      >
        <el-form
          :model="editForm"
          label-width="80px"
          :rules="editFormRules"
          ref="editForm"
        >
          <el-row>
            <el-col :span="22">
              <el-form-item label="账号" prop="phone">
                <el-input
                  disabled
                  v-model="editForm.phone"
                  auto-complete="off"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="22">
              <el-form-item label="姓名" prop="name">
                <el-input
                  v-model="editForm.name"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="22">
              <el-form-item label="类型" prop="type">
                <el-select v-model="editForm.type">
                  <el-option
                    v-for="item in types"
                    :label="item.label"
                    :key="item.value"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="22">
              <el-form-item label="密码" prop="password">
                <el-input
                  type="password"
                  v-model="editForm.password"
                  auto-complete="off"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="22">
              <el-form-item label="确认密码" prop="conpassword">
                <el-input
                  type="password"
                  v-model="editForm.conpassword"
                  auto-complete="off"
                  @keyup.enter.native="editSubmit"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: center">
          <el-button @click.native="editFormVisible = false">取消</el-button>
          <el-button
            type="primary"
            @click.native="editSubmit"
            :loading="editLoading"
            >提交</el-button
          >
        </div>
      </el-dialog>
    </template>

    <template v-slot:ft>
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination
          layout="sizes, prev, pager, next"
          :page-sizes="[10, 20, 30, 50, 100]"
          :current-page="pageNumber"
          :page-size="pageSize"
          :total="total"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          style="float: right"
        >
        </el-pagination>
      </el-col>
    </template>
  </BaseContainer>
</template>
<script>
import { API__code, API_Admin } from "../../../api/index.js";
import BaseContainer from "@/components/BaseContainer";
import fitTableHeight from "@/mixins/fitTableHeight.js";
export default {
  mixins: [fitTableHeight],
  data() {
    return {
      types: [
        { value: "1", label: "系统管理员" },
        { value: "2", label: "客户经理" },
        { value: "3", label: "客户成功经理" },
        { value: "4", label: "经销商" },
      ],
      // delShow:true,
      total: 0,
      pageNumber: 1,
      pageSize: 20,
      id: "",
      token: "",
      checkCode: "",
      users: [],
      listLoading: false,
      souchs: {},
      addFormVisible: false,
      addForm: {},
      addLoading: false,
      addFormRules: {
        user: [{ required: true, message: "请输入账号", trigger: "blur" }],
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        type: [{ required: true, message: "请选择类型", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },

      editForm: {
        name: "",
        phone: "",
        type: "",
        password: "",
        conpassword: "",
      },
      editFormVisible: false,
      editLoading: false,
      editFormRules: {
        user: [{ required: true, message: "请输入账号", trigger: "blur" }],
        name: [{ required: true, message: "请输入标题", trigger: "blur" }],
        type: [{ required: true, message: "请选择类型", trigger: "blur" }],
        password: [{ required: false, message: "密码", trigger: "blur" }],
        conpassword: [
          { required: false, message: "确认密码", trigger: "blur" },
        ],
      },
    };
  },

  components: {
    BaseContainer,
  },

  methods: {
    editSubmit: function () {
      this.$refs["editForm"].validate((valid) => {
        if (valid) {
          this.editLoading = true;
          let param = {
            token: this.token,
            checkCode: this.checkCode,
            id: this.editForm.id,
            user: this.editForm.phone,
            name: this.editForm.name,
            type: this.editForm.type,
          };
          if (this.editForm.password) {
            param.password = this.editForm.password;
            param.conpassword = this.editForm.conpassword;
          }
          API_Admin.editAdmin(param)
            .then((res) => {
              if (res.data.code == API__code.SUCCESS) {
                this.$message({
                  message: "修改成功",
                  type: "success",
                });
                this.editFormVisible = false;
                this.getUser();
              } else {
                this.$message.error(res.data.message);
                if (res.data.code == 403) {
                  this.$router.push({ path: "loginAdmin" });
                }
              }
              this.editLoading = false;
            })
            .catch((err) => {
              this.editLoading = false;
              this.$message.error("服务器异常，请您稍后再试..");
            });
        }
      });
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true;
      this.editForm.id = row.id;
      this.editForm.phone = row.phone;
      this.editForm.name = row.name;
      this.editForm.type = row.type;
      //this.editForm = Object.assign({}, row);
    },
    //删除
    handleDel: function (index, row) {
      this.$confirm("确认删除该用户吗?", "提示", {
        type: "warning",
      }).then(() => {
        let para = {
          id: row.id,
          token: this.token,
          checkCode: this.checkCode,
        };
        API_Admin.delAdmin(para).then((res) => {
          if (res.data.code == API__code.SUCCESS) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getUser();
          } else {
            this.$message.error(res.data.message);
            if (res.data.code == 403) {
              this.$router.push({ path: "loginAdmin" });
            }
          }
        });
      });
    },
    addSubmit: function () {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          let param = {
            // id:this.id,
            token: this.token,
            checkCode: this.checkCode,
            user: this.addForm.user,
            password: this.addForm.password,
            name: this.addForm.name,
            type: this.addForm.type,
            // beizhu:this.addForm.beizhu
          };
          this.addLoading = true;
          API_Admin.setAdmin(param)
            .then((res) => {
              if (res.data.code == API__code.SUCCESS) {
                this.$message({
                  message: "新增成功",
                  type: "success",
                  center: true,
                });

                this.addFormVisible = false;
                this.addForm = {};
                this.getUser();
              } else {
                this.$message.error(res.data.message);
                if (res.data.code == 403) {
                  this.$router.push({ path: "loginAdmin" });
                }
              }
              this.addLoading = false;
            })
            .catch((err) => {
              this.$message.error("服务器异常，请您稍后再试..");
              this.addLoading = false;
            });
        }
      });
    },
    closeAddform() {
      this.$refs["addForm"].clearValidate();
    },
    closeeditForm() {
      this.$refs["editForm"].clearValidate();
    },
    indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * this.pageSize;
    },
    handleCurrentChange(val) {
      this.pageNumber = val;
      this.getUser();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getUser();
    },
    //显示新增界面
    handleAdd: function () {
      this.addForm = {};
      this.addFormVisible = true;
    },
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex == 0) {
        return "background:#F5F7FA";
      } else {
        return "";
      }
    },
    selsChange: function (sels) {
      this.sels = sels;
    },
    handleSortChange: function (val) {
      if (val) {
        if (val.prop == "name") {
          this.orderStr = "namepx";
        } else if (val.prop == "phone") {
          this.orderStr = "phonepx";
        } else if (val.prop == "intime") {
          this.orderStr = "intimepx";
        }
        if (val.order == "descending") {
          this.orderType = "desc";
        } else {
          this.orderType = "asc";
        }
      }
      this.getUser();
    },
    getUser: function (val) {
      let _this = this;
      if (val == 1) {
        this.pageNumber = 1;
      }
      let param = {
        searchName: this.souchs.name,
        token: this.token,
        checkCode: this.checkCode,
        listType: "page",
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,

        orderStr: this.orderStr,
        orderType: this.orderType,
      };
      this.listLoading = true;
      API_Admin.getAdminList(param)
        .then((res) => {
          if (res.data.code == API__code.SUCCESS) {
            if (res.data.data) {
              _this.total = res.data.data.totalRow;
            }
            _this.users = res.data.data.list;
            for (var i = 0; i < this.users.length; i++) {
              if (_this.users[i].phone == this.token) {
                _this.users[i].delShow = true;
              } else {
                _this.users[i].delShow = false;
              }

              if (_this.users[i].type == 1) {
                _this.users[i].types = "系统管理员";
              } else {
                _this.users[i].types = "普通管理员";
              }
            }
          } else {
            this.$message.error(res.data.message);
            if (res.data.code == 403) {
              this.$router.push({ path: "loginAdmin" });
            }
          }
          this.listLoading = false;
        })
        .catch((err) => {
          this.$message.error("服务器异常，请您稍后再试..");
          this.listLoading = false;
        });
    },
    //读取cookie
    getCookie: function () {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split("; "); //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("="); //再次切割
          //判断查找相对应的值
          if (arr2[0] == "dnnyptadmin_token") {
            this.token = arr2[1]; //保存到保存数据的地方
          } else if (arr2[0] == "dnnyptadmin_checkCode") {
            this.checkCode = arr2[1];
          } else if (arr2[0] == "dnnyptadmin_id") {
            this.id = arr2[1];
          }
        }
      }
    },
  },
  created() {
    this.getCookie();
  },
  mounted() {
    this.getUser();
  },
};
</script>
<style lang="scss">
.dnnCloud-admin-box {
  .base-container-bd {
    .content-hd {
      .el-form-item {
        margin-bottom: 0;
      }
    }
  }
}
</style>
<style scoped>
.el-select {
  display: inline-block;
  position: relative;
  width: 130px;
}
</style>



// WEBPACK FOOTER //
// Admin.vue?0dab7b8c